import { OptionButtons, OptionButtonsPropsBase } from "~Components/OptionButtons"
import { DeliveryNoteTableColumn } from "~Features/pages/deliveryNotes/types/deliveryNote.interfaces"
import { AuthzService } from "~Shared/services"

export const DeliveryNoteOptionButtons = ({ record, onEdit, onDelete, onView, children }: OptionButtonsPropsBase<DeliveryNoteTableColumn>) => {
    const isEditDisabled = record ? !AuthzService.hasUserUpdateRightsForDeliveryNote(record) : true
    return OptionButtons<DeliveryNoteTableColumn>({ record, onEdit, onDelete, onView, children, isEditDisabled, isDeleteDisabled: isEditDisabled })
}
